module.exports = __webpack_public_path__ + "static/media/gas_desc.eaab3fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/views/gas/gas_desc.png
// module id = 1596
// module chunks = 0